<template>
  <!-- Add image Card -->
  <div class="card">
    <!-- Header -->
    <div class="card-header">
      <div class="row">
        <!-- Tabs -->
        <ul class="col nav">
          <li
            class="nav-item"
            v-for="(tab, index) in addImagesTab"
            :key="index"
          >
            <button
              class="btn"
              :class="index == addImagesTabActive ? 'active' : ''"
              @click="addImagesTabActive = index"
            >
              {{ tab }}
            </button>
          </li>
        </ul>

        <!-- History button -->
        <!-- <div class="col col-1 p-1 text-end">
          <button type="button" @click="close">
            <i class="bi bi-x"></i>
          </button>
        </div> -->

        <!-- Close button -->
        <div class="col col-1 p-1 text-end">
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            data-bs-toggle="collapse"
            data-bs-target=".multi-collapse"
            @click="close"
          ></button>
        </div>
      </div>
    </div>

    <!-- Body -->
    <div class="card-body">
      <!-- Image placeholder -->
      <svg
        class="card-img-top mb-0"
        width="606"
        height="606"
        xmlns="http://www.w3.org/2000/svg"
        v-show="!imageTitleLoaded"
      >
        <rect
          x="0"
          y="0"
          width="606"
          height="606"
          fill="none"
          stroke="gray"
          stroke-width="1"
        />
      </svg>

      <!-- Image -->
      <img
        class="card-img-top mb-0"
        :src="imageUrl + '/api/v1/images.get.preview.tag.img/imgen-add'"
        @load="imageTitleLoaded = true"
      />
      <div class="mb-3">
        <small class="text-secondary">Teonet AI image generator</small>
      </div>

      <!-- Add image from URL -->
      <form
        v-on:submit="doAddUrl(newUrl)"
        v-if="addImagesTab[addImagesTabActive] == 'URL'"
      >
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="newUrl"
            placeholder="Enter image URL"
            required
          />
          <button disabled type="submit" class="btn btn-primary">Add</button>
        </div>
      </form>

      <!-- Add image from File -->
      <form
        v-on:submit="doAddFile(newFile)"
        v-if="addImagesTab[addImagesTabActive] == 'File'"
      >
        <div class="input-group">
          <input
            type="file"
            class="form-control"
            id="formFile"
            required
            @change="
              (file) => {
                newFile = file;
                console.debug(file);
              }
            "
          />
          <button disabled type="submit" class="btn btn-primary">Add</button>
        </div>
      </form>

      <!-- Generate image -->
      <form
        v-if="addImagesTab[addImagesTabActive] == 'Generate'"
        action="javascript:void(0);"
      >
        <div class="input-group">
          <textarea
            type="text"
            class="form-control"
            v-model="prompt"
            placeholder="Enter text to generate new image"
            required
            rows="1"
            ref="textarea"
            @focus="resize"
            @keyup="resize"
          ></textarea>
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="showSettings = !showSettings; setLocalStorage()"
          >
            <i class="bi bi-gear"></i>
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            @click="doConfirmGenerate(prompt, settings.style, settings.speed)"
          >
            Gen
          </button>
        </div>

        <!-- Settings -->
        <div v-if="showSettings" class="mt-3">
          <!-- Balance -->
          <div class="mb-2">
            Balance rpoints:
            <span
              v-if="balance === undefined"
              class="spinner-grow"
              role="status"
            >
            </span>
            <span v-else>{{ balance }}</span>
          </div>

          <!-- Style -->
          <div>
            <div
              class="mb-2 dropdown-btn dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style="cursor: pointer"
            >
              Style: {{ settings.style }} =>
              {{ settings.styles[settings.style].name }}
              <i class="bi bi-clock-history p-1 border rounded"></i>
            </div>

            <ul class="card dropdown-menu">
              <!-- Style items -->
              <li
                v-for="(style, idx) in settings.styles"
                :key="idx"
                :value="style.id"
              >
                <div>
                  <!-- Divider or empty space -->
                  <hr v-if="idx > 0" class="dropdown-divider" />
                  <div v-else class="mb-2"></div>

                  <!-- Filter content -->
                  <a
                    class="dropdown-item p-2"
                    @click="settings.style = style.id"
                  >
                    {{ style.id }}. {{ style.name }}
                    <div v-show="style.loaded === true">
                      <img
                        :src="
                          imageUrl +
                          '/api/v1/images.get.preview.tag.img/style_' +
                          style.name
                        "
                        @load="style.loaded = true"
                        style="width: 200px"
                      />
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </form>

      <!-- Confirm actions -->
      <ActionConfirm
        class="mt-4"
        :action="actions[confirm]"
        @confirm="doAddGenerate"
        @cancel="confirm = ''"
      />
    </div>

    <div
      v-if="addImagesTab[addImagesTabActive] == 'Generate'"
      class="card-footer"
    >
      <!-- Generation started successfully -->
      <div v-show="generate == msgSuccess">
        <div class="alert alert-success mt-2" role="alert">
          Generation started.
        </div>

        <small
          >Image generation may take a few minutes (up to 10 minutes). After
          images have been generated, it will be available in images list.<br />
          <br />
          You can check generation status by press the 'Check generation' button
          below.</small
        >

        <div class="mt-4">Generation id: {{ generateId }}</div>

        <button class="btn btn-primary mt-2" @click="doCheckGenerate">
          Check generation
        </button>

        <div class="mt-2">{{ generateMsg }}</div>

        <div v-for="(image, index) in generateImg" :key="index">
          <img
            class="img-fluid mt-2"
            :src="imageUrl + '/api/v1/images.get.preview/' + image"
          />
        </div>
      </div>

      <!-- Generation failed -->
      <div v-show="generate == msgFailed">
        <div class="alert alert-danger" role="alert">Generation failed.</div>
        {{ generateMsg }}
      </div>
    </div>
  </div>
</template>

<script>
import ActionConfirm from "./ActionConfirm.vue";

const cmdBalance = "images.gen.balance";
const cmdImageGenerate = "images.gen";
const cmdImageGenerateStatus = "images.gen.status";

export default {
  name: "ImageAdd",

  components: {
    ActionConfirm,
  },

  props: {
    styles: Array,
    imageUrl: String,
  },

  data() {
    return {
      addImagesTab: ["Generate", "URL", "File"],
      addImagesTabActive: 0,
      showSettings: false,

      newFile: {},
      newUrl: "",
      prompt: "",

      balance: undefined,

      imageTitleLoaded: false,

      settings: {
        style: 0,
        speed: "relax",
        styles: this.styles,
      },

      // confirm action
      confirm: "",
      actions: {
        generate: {
          name: "generate",
          text: "Generate image?",
          word: "generate",
        },
      },

      // Generation status
      generate: "123",
      generateId: 1013358,
      generateMsg: "",
      generateImg: [],
      msgSuccess: "success",
      msgFailed: "failed",
    };
  },

  mounted() {
    this.getLocalStorage();
    this.getBalance();
  },

  methods: {
    doAddUrl(url) {
      console.debug("doAddUrl", url);

      this.close();
    },

    doAddFile(file) {
      console.debug("doAddFile", file);

      this.close();
    },

    doConfirmGenerate(prompt, style, speed) {
      console.debug("doConfirmGenerate:", prompt, style, speed);
      this.confirm = "generate";
    },

    doAddGenerate() {
      const prompt = this.prompt;
      const style = this.settings.style;
      const speed = this.settings.speed;
      console.debug("doAddGenerate:", prompt, style, speed);

      this.setLocalStorage();
      this.sendCmd(cmdImageGenerate + "/" + style + "/", prompt).then(
        // Process success answer
        (id) => {
          console.debug("image generation processing, id:", id);
          this.generate = this.msgSuccess;
          this.generateId = id;
          // this.close();
        },
        // Process an error
        (err) => {
          console.error("image generation error:", err);
          this.generate = this.msgFailed;
          this.generateMsg = err;
          // this.close();
        }
      );
    },

    doCheckGenerate() {
      this.generateMsg = "Checking...";
      this.generateImg = [];
      this.sendCmd(cmdImageGenerateStatus + "/" + this.generateId).then(
        // Process success answer
        (data) => {
          let status = JSON.parse(data);
          console.debug("doCheckGenerate", status);
          if (status.completed) {
            this.generateMsg =
              "Completed, generated " + status.names.length + " images";
            this.generateImg = status.names;
          } else {
            this.generateMsg = "Processing...";
          }
        },
        // Process an error
        (err) => {
          console.error("doCheckGenerate error:", err);
          this.generateMsg = "Error: " + err;
          // this.close();
        }
      );
    },

    getBalance() {
      this.sendCmd(cmdBalance).then(
        // Process success answer
        (data) => {
          console.debug("getBalance", data);
          this.balance = JSON.parse(data);
        },
        // Process an error
        (err) => {
          console.error("getBalance error:", err);
        }
      );
    },

    close() {
      setTimeout(() => this.$emit("close"));
    },

    resize(event) {
      if (event.ctrlKey && event.key === "Enter") {
        // this.getNextPage();
      }
      const { textarea } = this.$refs;
      textarea.style.height = textarea.scrollHeight + "px";
    },

    getLocalStorage() {
      if (localStorage.images) {
        let images = JSON.parse(localStorage.images);
        this.showSettings = images.showSettings;
        this.settings.style = images.style;
        this.prompt = images.prompt;
      }
    },

    setLocalStorage() {
      localStorage.images = JSON.stringify({
        showSettings: this.showSettings,
        style: this.settings.style,
        prompt: this.prompt,
      });
    },
  },
};
</script>

<style scoped>
.close {
  margin-top: -3.3rem;
}

.dropdown-menu {
  padding-top: 0%;
  max-height: 765px;
  overflow-y: auto;
  overflow-x: hidden;
}
.card.dropdown-menu {
  display: none;
}
.card.dropdown-menu.show {
  display: block;
}
.dropdown-btn i {
  opacity: 0.5;
}
.dropdown-btn i:hover {
  opacity: 1;
}

.spinner-grow {
  width: 15px;
  height: 15px;
}

svg {
  width: auto;
  height: auto;
  max-width: 100%;
}
</style>
